<template>
  <div
    class="modal fade"
    id="changelogModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>Changelog</b>
          </h4>
        </div>
        <div class="modal-body">
          <div v-for="(content, version) in changelog" :key="version">
            <template
              v-if="
                version === 'dev' &&
                ['dev', 'training', 'dev-audi', 'training-audi'].indexOf(
                  feature.currentTarget
                ) > -1
              "
            >
              <span class="version-number">In Progress</span>
              <div
                v-for="(entry, index) of content.changes"
                :key="index"
                class="change-entry"
              >
                ● {{ entry }}
              </div>
              <hr />
            </template>
            <template v-if="version !== 'dev'">
              <span class="version-number">v{{ version }}</span>
              <span class="version-date">({{ content.date }})</span>
              <div
                v-for="(entry, index) of content.changes"
                :key="index"
                class="change-entry"
              >
                ● {{ entry }}
              </div>
              <hr />
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as changelog from "../../../../changelog.json";

export default {
  name: "ChangelogModal",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openChangelogModal() {
      $("#changelogModal").modal("show");
    },
    closeChangelogModal() {
      $("#changelogModal").modal("hide");
    },
  },
  mounted() {
    $("#changelogModal").on("hide.bs.modal", (e) => this.$emit("closeDialog"));
  },
  watch: {
    showDialog(newValue) {
      if (newValue) {
        this.openChangelogModal();
      } else {
        this.closeChangelogModal();
      }
    },
  },
  data() {
    return {
      changelog: changelog,
    };
  },
};
</script>

<style scoped>
.modal-footer {
  text-align: center;
  margin-top: 10px;
}

.modal-body {
  text-align: left;
  max-height: calc(100vh - 200px);
  overflow: auto;
}
.modal-body hr {
  border-width: 3px;
  margin: 15px 0;
}

.version-number {
  font-size: 1.8em;
}

.version-date {
  font-size: 1.2em;
}

.change-entry {
  font-size: 1em;
  margin: 0.2em 1.5em;
}
</style>



// WEBPACK FOOTER //
// ChangelogModal.vue?adf8f13e